import { bootstrapWidget } from "../../common";
import GalleryWidget from "./widget";

bootstrapWidget({ widget: GalleryWidget, widgetType: "gallery" });
